<template>
  <div
    :class="$style.root"
    :data-multiple="images?.length > 1 ? '' : null"
    :data-within-modal="withinModal ? '' : null"
  >
    <CoreImageSliderComponent
      :images="images"
    />
  </div>
</template>

<script setup>
import { sampleSize } from 'lodash-es'

const props = defineProps({
  block: Object,
  withinModal: {
    type: Boolean,
    default: false
  }
})

const images = computed(() => {
  return i18nGetLocalizedData(props?.block)?.images?.data
})

const randomImages = computed(() => {
  return sampleSize(images.value, 3)
})

const viewOption = computed(() => {
  return i18nGetLocalizedData(props?.block)?.view_option
})
</script>

<style module lang="scss">
.root {
  composes: container--default from global;
  // --base--image--height: var(--100svh);
  --base--image--object-fit: cover;
}

.root[data-within-modal] {
  padding: 0 var(--unit--horizontal);
}
</style>
